<template>
  <div class="mapDiv">
    <br>
    <GmapMap
      :center="center"
      :zoom="12"
      style="width:100%;  height: 400px;"
    />
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
// import引入的组件需要注入到对象中才能使用
  name: 'GoogleMap',
  components: {},
  data() {
    // 这里存放数据
    return {
      formLabelWidth: '120px',
      center: { lat: 40.6980, lng: -111.8916 }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  mounted() {
    this.geolocate()
  },
  // 监控data中的数据变化
  // 方法集合
  methods: {
    geolocate: function() {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          // lat: position.coords.latitude,
          // lng: position.coords.longitude
          lat: 40.6980,
          lng: -111.8916
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.mapDiv{
  width: 100%;
  padding: 10px 30px;
}
@media only screen and (max-width: 1299px) {
  .mapDiv {
    max-width: 1310px;
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoogleMap/GoogleMap.vue